import { render } from "./CreateSchedule.vue?vue&type=template&id=6c0d2625"
import script from "./CreateSchedule.vue?vue&type=script&lang=js"
export * from "./CreateSchedule.vue?vue&type=script&lang=js"

import "./CreateSchedule.vue?vue&type=style&index=0&id=6c0d2625&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__